import React from "react";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { Divider, Grid, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBirthdayCake } from "@fortawesome/free-solid-svg-icons";
import { intlFormatDateShort } from "../../../utils/time-utils";
import { EmployeeDTO } from "../../../models/employees";

interface Props {
  employee: EmployeeDTO | null;
  buttonToRender: JSX.Element;
}
const EmployeeHeader = ({ employee, buttonToRender }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Grid
      style={{
        backgroundColor: theme.palette.background.paper,
        display: "flex",
        gap: "20px",
        borderRadius: "3px",
        padding: "5px",
        alignItems: "center",
      }}
    >
      <Grid
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "10px",
          height: "100%",
        }}
      >
        <Typography
          variant="h6"
          style={{ color: theme.palette.text.disabled }}
        >{`${t(`common_words.employee`)}`}</Typography>

        <Divider orientation="vertical" />

        {employee && (
          <Grid
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography variant="h6">{employee?.name}</Typography>
            {employee?.birthDate && (
              <Typography variant={"body2"}>
                <FontAwesomeIcon
                  icon={faBirthdayCake}
                  size="xs"
                />{" "}
                &nbsp;
                {intlFormatDateShort(employee.birthDate)}
              </Typography>
            )}
            <Typography
              style={{ color: theme.palette.text.disabled }}
              variant={"body2"}
              title={employee?.legalEntity?.name}
            >
              {employee?.legalEntity?.code ?? employee?.legalEntity?.name}
            </Typography>
          </Grid>
        )}
      </Grid>
      {buttonToRender}
    </Grid>
  );
};
export default EmployeeHeader;
